import React from 'react';
import PropTypes from 'prop-types';

const RatingStar = ({ isEmpty }) => (
  <i
    className={`bra-icn ${isEmpty ? 'bra-icn__outline-star' : 'bra-icn__star'}`}
    data-class={isEmpty ? 'bra-icn__outline-star' : 'bra-icn__star'}
  />
);

RatingStar.propTypes = {
  isEmpty: PropTypes.bool.isRequired,
};

export default RatingStar;
